import cc from 'currency-codes'
import getSymbolFromCurrency from 'currency-symbol-map'
import { useTranslation } from 'react-i18next'
import { Currency } from 'src/api/currency'

export default function useFormatCurrency() {
  const { i18n } = useTranslation()

  const formatCurrency = (integerAmount: number, currency: Currency) => {
    const digits = cc.code(currency)?.digits || 2
    return new Intl.NumberFormat(i18n.language, { style: 'currency', currency: currency, maximumFractionDigits: digits, minimumFractionDigits: digits })
      .format(integerAmount / 10 ** digits)
      .replace(currency.toString(), getSymbolFromCurrency(currency) ?? currency)
  }

  const formatTableCurrency = (integerAmount: number, currency: Currency) => {
    const digits = cc.code(currency)?.digits || 2
    return `${new Intl.NumberFormat(i18n.language, { maximumFractionDigits: digits, minimumFractionDigits: digits }).format(integerAmount / 10 ** digits)} ${getSymbolFromCurrency(currency)}`
  }

  const formatAmount = (integerAmount: number, currency: Currency) => {
    const digits = cc.code(currency)?.digits || 2
    return new Intl.NumberFormat(i18n.language, { maximumFractionDigits: digits, minimumFractionDigits: digits }).format(integerAmount / 10 ** digits)
  }

  const formatCurrencyWithoutDecimals = (integerAmount: number, currency: Currency) => {
    const digits = cc.code(currency)?.digits || 2

    return new Intl.NumberFormat(i18n.language, { style: 'currency', currency: currency, maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(integerAmount / 10 ** digits)
  }

  return { formatCurrency, formatTableCurrency, formatAmount, formatCurrencyWithoutDecimals }
}
